import * as React from 'react'
import { Box } from "@mui/material"


export default function prevTotalColumn() {
	return {
		name: 'prevTotalProduct', label: 'Previous Total Products',
		options: {
			filter: false,
			customBodyRowRenderLite: value => <Box sx={{textAlign: 'center'}}>
				{value}
			</Box>
		}
	}
}


